import { z } from 'zod';
export const previewBillingSchema = z
    .object({
    periodFrom: z.coerce.date(),
    periodTo: z.coerce.date(),
})
    .refine((v) => v.periodTo >= v.periodFrom, {
    message: 'periodTo must be on or after periodFrom',
    path: ['periodTo'],
});
export const createBillingBatchSchema = previewBillingSchema;
//# sourceMappingURL=billing.js.map